// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file tab.proto (package grpc.api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file tab.proto.
 */
export const file_tab: GenFile = /*@__PURE__*/
  fileDesc("Cgl0YWIucHJvdG8SC2dycGMuYXBpLnYxIi4KA1RhYhIKCgJpZBgBIAEoAxINCgVvcmRlchgCIAEoBRIMCgRuYW1lGAMgASgJQgZaBC47cGJiBnByb3RvMw");

/**
 * @generated from message grpc.api.v1.Tab
 */
export type Tab = Message<"grpc.api.v1.Tab"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: int32 order = 2;
   */
  order: number;

  /**
   * @generated from field: string name = 3;
   */
  name: string;
};

/**
 * Describes the message grpc.api.v1.Tab.
 * Use `create(TabSchema)` to create a new message.
 */
export const TabSchema: GenMessage<Tab> = /*@__PURE__*/
  messageDesc(file_tab, 0);

